import ICity from '@models/city';
import IPaginatedParams from '@models/paginated-params';
import IPaginatedesponse from '@models/paginated-reponse';
import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

export const getCities = (
  params: IPaginatedParams,
): Promise<AxiosResponse<IPaginatedesponse<ICity>>> => {
  return axiosClient.get(EndPoints.city.getCities(params));
};
